import { connect } from 'react-redux'

import { actions as LKModalActions } from 'shared/LKModal'
import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { translateLKMessage } from '../../../translator'
import { deleteTag, deleteTagLoading } from 'src/store/loan'

export default connect(
  (state) => ({
    // loading: getPending('LoanDetailsDeleteTag')(state),
    loading: deleteTagLoading(state),
  }),
  (dispatch, ownProps) => ({
    openConfirmation: (ID, TagID) => {
      dispatch(
        LKModalActions.openConfirmation('LoanDetailsDeleteTag', {
          ID,
          TagID,
        }),
      )
    },

    deleteTag: ({ ID, TagID }) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: 'LoanDetailsDeleteTag',
      //     callApi: Loan.deleteTag,
      //     callApiArgs: [
      //       {
      //         LoanID: ownProps.ID,
      //         HashSum_LoanID_: ownProps.hash,
      //         ID,
      //         TagID,
      //       },
      //     ],
      //     resolve: () => {
      //       dispatch(
      //         DetailsContainerActions.fetchPage({
      //           type: 'Loan',
      //           ID: ownProps.ID,
      //           hash: ownProps.hash,
      //           page: 'tags',
      //         }),
      //       )
      //     },
      //     reject: (error) => {
      //       dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
      //     },
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page: 'tagdelete'
      dispatch(
        deleteTag({
          LoanID: ownProps.ID,
          HashSum_LoanID_: ownProps.hash,
          ID,
          TagID,
        }),
      )
        .then((response) => {
          if (!deleteTag.fulfilled.match(response)) {
            dispatch(LKModalActions.openInfo(translateLKMessage(response.payload)))
            return
          }
          dispatch(
            DetailsContainerActions.fetchPage({
              type: 'Loan',
              ID: ownProps.ID,
              hash: ownProps.hash,
              page: 'tags',
            }),
          )
        })
        .catch((error) => {
          console.error(error)
        })
    },
  }),
)
